import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendDown, faArrowTrendUp, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export function TrendValue({ value, inverse = false, neutral = false }) {
  if (value === null || value === undefined) {
    return <span className="text-[#6b7fa3]">N/A</span>;
  }
  const numericValue = Number(value);
  const isPositive = numericValue >= 0;
  const isGood = inverse ? !isPositive : isPositive;
  const tone = neutral ? "text-[#1a5691]" : isGood ? "text-[#047857]" : "text-[#dc2626]";
  const icon = isPositive ? faArrowTrendUp : faArrowTrendDown;
  const showConcern = !neutral && Math.abs(numericValue) > 15;

  return (
    <span className="inline-flex items-center gap-2">
      <span className={`inline-flex items-center gap-1 font-bold ${tone}`}>
        <FontAwesomeIcon icon={icon} className="text-[11px]" />
        {isPositive ? "+" : ""}
        {numericValue.toFixed(1)}%
      </span>
      {showConcern ? (
        <span
          className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-[#fff4e5] text-[#d97706]"
          title="Quarter-over-quarter change exceeds 15%"
        >
          <FontAwesomeIcon icon={faTriangleExclamation} className="text-[10px]" />
        </span>
      ) : null}
    </span>
  );
}
